export const VALIDATION_DEB_MS = 1000;
